export default "__VITE_ASSET__94a8f847__"